export default __webpack_public_path__ + "media/zurb/img/playground/uxm-icon-265d639f4af309962234a3f2950f95af.png";